import {NgModule} from '@angular/core';
import {MaterialModule} from './material/material.module';
import {CommonModule} from '@angular/common';
import {HAMMER_GESTURE_CONFIG, HammerModule} from '@angular/platform-browser';
import {HammerConfig} from './gestures/hammer.config';
import {AvatarComponent} from './avatar/avatar.component';
import {I18nModule} from './i18n/i18n.module';
import {AuthModule} from './auth/auth.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {PaginatorComponent} from './pagination/paginator/paginator.component';
import {SortButtonComponent} from './sort/sort-button.component';
import {NotificationComponent} from './notification/notification.component';
import {ErrorInterceptor} from './error/error.interceptor';
import {FocusDirective} from './focus/focus.directive';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ConfirmationComponent} from './dialog/confirmation/confirmation.component';
import {ZXingScannerModule} from '@zxing/ngx-scanner';
import {SelectComponent} from './dialog/select/select.component';
import {InformationComponent} from './dialog/information/information.component';
import {TextareaComponent} from './dialog/textarea/textarea.component';
import {PeriodePipe} from './date/periode.pipe';
import {IconAvatarComponent} from './icon-avatar/icon-avatar.component';
import {MiniPaginatorComponent} from './pagination/mini-paginator/mini-paginator.component';

@NgModule({ declarations: [
        AvatarComponent,
        IconAvatarComponent,
        PaginatorComponent,
        MiniPaginatorComponent,
        SortButtonComponent,
        NotificationComponent,
        FocusDirective,
        InformationComponent,
        ConfirmationComponent,
        SelectComponent,
        TextareaComponent,
        PeriodePipe,
    ],
    exports: [
        MaterialModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        HammerModule,
        AuthModule,
        I18nModule,
        ZXingScannerModule,
        AvatarComponent,
        IconAvatarComponent,
        PaginatorComponent,
        MiniPaginatorComponent,
        SortButtonComponent,
        FocusDirective,
        PeriodePipe,
    ], imports: [MaterialModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        HammerModule,
        AuthModule,
        I18nModule,
        ZXingScannerModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {
}
